export enum ConversationMessageMediaItemType {
    ContentLibraryImage = 'contentLibraryImage',
    ContentLibraryVideo = 'contentLibraryVideo',
}
